import L from "leaflet";
import { MyLeaf } from "./my_leaf";
import store from "@/store";
import * as utils from "@/utils/utils";
import { eventBus } from "@/main";
import "leaflet-rotatedmarker";
import "leaflet-draw";
import "leaflet-spin";
import "leaflet-contextmenu-bootstrap";
import "leaflet-contextmenu-bootstrap/dist/leaflet.contextmenu.min";
import { CURRENT_PRODUCT } from "@/utils/build-config";
import { useRoutesStore } from "@/stores/routes";
import { useEditorStore } from "@/stores/editor";
import { useLogbookStore } from "@/stores/logbook";
import { useFleetStore } from "@/stores/fleet";
import { useDeviceStore } from "@/stores/device";
import { useCatalogsStore } from "@/stores/catalogs";
import { useCartStore } from "@/stores/cart";
import { useMomentaryStore } from "@/stores/momentary";
import { GeoUtils } from "@/utils/geo-utils";

// Расширяем L.TileLayer для поддержки токенов
L.TileLayer.FetchTokenLayer = L.TileLayer.extend({
  initialize: function (url, options) {
    this._token = options.token;
    L.TileLayer.prototype.initialize.call(this, url, options);
  },
  createTile: function (coords, done) {
    const tile = document.createElement("img");
    tile.alt = "";
    tile.setAttribute("role", "presentation");

    tile.onload = function () {
      done(null, tile);
    };

    tile.onerror = function (err) {
      done(err, tile);
    };

    const url = this.getTileUrl(coords);
    fetch(url, {
      headers: {
        Authorization: "Bearer " + this._token,
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.blob();
      })
      .then((blob) => {
        tile.src = URL.createObjectURL(blob);
      })
      .catch((err) => {
        console.error(err);
        done(err, tile);
      });

    return tile;
  },
});

L.tileLayer.fetchTokenLayer = function (url, options) {
  return new L.TileLayer.FetchTokenLayer(url, options);
};

// Класс NavLeaf, расширяющий MyLeaf для навигационной карты (без канваса)
export class NavLeaf extends MyLeaf {
  editorStore = null;

  routesStore = null;

  fleetStore = null;

  momentaryStore = null;

  logbookStore = null;

  deviceStore = null;

  cartStore = null;

  catalogsStore = null;

  constructor() {
    super();
    this.markerLayer = L.layerGroup();
    this.shipData = {};
  }

  // Инициализация карты
  async init(el, viewType) {
    this.routesStore = useRoutesStore();
    this.fleetStore = useFleetStore();
    this.editorStore = useEditorStore();
    this.logbookStore = useLogbookStore();
    this.momentaryStore = useMomentaryStore();
    this.deviceStore = useDeviceStore();
    this.cartStore = useCartStore();
    this.catalogsStore = useCatalogsStore();

    let url = "https://tile.openstreetmap.org/{z}/{x}/{y}.png";

    // Получаем сохраненное состояние карты из momentary store
    const savedMapState = this.momentaryStore.getMapState();

    // Используем сохраненное состояние если оно есть, иначе данные из старого store или значения по умолчанию
    let center = [savedMapState.lat, savedMapState.lon];
    let zoom = savedMapState.zoom;

    // Ждем асинхронную инициализацию карты
    await super.init(el, url, center, zoom, 2, 20); 

    if (!this.map) {
      console.error('nav-leaf.js: Map was not initialized after super.init()');
      return;
    }

    let tooltipPane = this.map.createPane("aaa");
    tooltipPane.style.zIndex = 810;
    let deviceId = this.deviceStore.getDeviceID;
    let draught = this.routesStore.getShipNoGo;
    let useGoodTiles = this.routesStore.getShipUseGoodTiles;
    let navURL = "";
    let user = store.state.auth.user.email;

    // Выдаем не блюреные тайлы для некоторых пользователей
    if (
      useGoodTiles === true ||
      user === "nnmk.8848+game1@gmail.com" ||
      user === "dovgan.anna@gmail.com" ||
      user === "evmuryshkin@gmail.com"
    )
      navURL =
        "https://mwend.bgeo.fi/api/v1/nogotile/{z}/{x}/{y}/?depth=" + draught;
    else {
      navURL =
        "https://mwend.bgeo.fi/api/v1/nogotile/{z}/{x}/{y}/?depth=" +
        draught +
        "&deviceId=" +
        deviceId;
      if (deviceId === "")
        navURL =
          "https://mwend.bgeo.fi/api/v1/nogotile/{z}/{x}/{y}/?depth=" +
          draught +
          "&deviceId=0";
    }

    let opacity = 1;

    // Карта мира
    if (viewType === "tokenView101") {
      navURL = "https://ntiles.bgeo.fi:6029/map/{z}/{x}/{y}";
      opacity = 0.5;
    }

    let token = store.state.auth.user.token;
    console.log("token", token);
    if (!CURRENT_PRODUCT.is_navicom) {
      this.navalLayer = L.tileLayer
        .fetchTokenLayer(navURL, {
          token: token,
          minZoom: 2,
          maxZoom: 20,
          opacity: opacity,
        })
        .addTo(this.map);
    }

    if (viewType !== "tokenView" && viewType !== "tokenView101") {
      this.multiTilesStateControl = new L.Control.EasyButton({
        position: "bottomleft",
        states: [
          {
            stateName: "on", // name the state
            icon: "bi bi-toggle-on", // and define its properties
            title: "Toggle S63/OSM", // like its title
            onClick: (btn) => {
              // and its callback
              this.navalLayer.remove();
              btn.state("off"); // change state on click!
            },
          },
          {
            stateName: "off",
            icon: "bi bi-toggle-off",
            title: "Toggle S63/OSM",
            onClick: (btn) => {
              this.navalLayer.addTo(this.map);
              btn.state("on");
            },
          },
        ],
      }).addTo(this.map);
    }

    this.addCoordinateInputControl();

    this.map.createPane("pMeasure");
    let a = this.map.getPane("pMeasure");
    a.style.zIndex = 720;
    this.pmPane = L.layerGroup({}, { pane: "pMeasure" }).addTo(this.map);

    let shipPane = this.map.createPane("sss");
    tooltipPane.style.zIndex = 800;

    this.markerLayer.addTo(this.map);
    eventBus.$on("remove-primar-tiles", () => {
      this.navalLayer.remove();
    });

    eventBus.$on("restore-primar-tiles", () => {
      this.navalLayer.addTo(this.map);
    });

    // Добавляем слушатели для сохранения состояния карты
    this.setupMapStateListeners();
  }

  // Настройка слушателей для сохранения состояния карты (центр/зум)
  setupMapStateListeners() {
    if (!this.map || !this.momentaryStore) return;

    // Сохраняем состояние карты при изменении вида (перемещение/зум)
    this.map.on("moveend zoomend", () => {
      const center = this.map.getCenter();
      const zoom = this.map.getZoom();
      this.momentaryStore.saveMapState(center.lat, center.lng, zoom);
    });
  }

  // Добавляем контрол ввода координат
  addCoordinateInputControl() {
    // Создаем контрол для ввода координат
    L.Control.CoordInput = L.Control.extend({
      options: {
        position: "bottomleft",
      },

      onAdd: function (map) {
        // Создаем контейнер для контрола
        const container = L.DomUtil.create(
          "div",
          "leaflet-control leaflet-bar leaflet-control-coord-input"
        );

        // Создаем кнопку для открытия диалога ввода
        const button = L.DomUtil.create("a", "", container);
        button.href = "#";
        button.title = "Go to coordinates";
        button.innerHTML = '<i class="bi bi-geo-alt"></i>';

        // Запрещаем всплытие событий клика и прокрутки
        L.DomEvent.disableClickPropagation(container);
        L.DomEvent.disableScrollPropagation(container);

        // Добавляем обработчик клика
        L.DomEvent.on(button, "click", function (e) {
          L.DomEvent.stop(e);

          // Запрашиваем координаты
          const coordStr = window.prompt("Enter coordinates (lat, lng):", "");
          if (coordStr) {
            // Парсим координаты
            const coords = coordStr.split(",").map((c) => parseFloat(c.trim()));

            if (coords.length >= 2 && !isNaN(coords[0]) && !isNaN(coords[1])) {
              // Координаты валидны
              const lat = coords[0];
              const lng = GeoUtils.normalizedLon(coords[1]);

              // Проверяем, что координаты в допустимом диапазоне
              if (lat >= -90 && lat <= 90 && lng >= -180 && lng <= 180) {
                map.setView([lat, lng], map.getZoom());
              } else {
                alert(
                  "Invalid coordinates range. Latitude: -90 to 90, Longitude: -180 to 180"
                );
              }
            } else {
              alert("Invalid coordinates format. Please use: lat, lng");
            }
          }
        });

        return container;
      },
    });

    // Добавляем кастомный контрол на карту
    new L.Control.CoordInput().addTo(this.map);

    // Добавляем CSS для иконки кнопки
    const style = document.createElement("style");
    style.innerHTML = `
        .leaflet-control-coord-input a {
            background-color: #fff;
            width: 30px;
            height: 30px;
            display: flex;
            align-items: center;
            justify-content: center;
        }
        .leaflet-control-coord-input a:hover {
            background-color: #f4f4f4;
        }
    `;
    document.head.appendChild(style);
  }

  // Добавляем навигационный слой
  addNavLayer() {
    if (this.navalLayer) this.navalLayer.remove();
    let draught = this.routesStore.getShipNoGo;
    let deviceId = this.deviceStore.getDeviceID;
    let useGoodTiles = this.routesStore.getShipUseGoodTiles;

    let navURL = "";
    if (useGoodTiles === true)
      navURL =
        "https://mwend.bgeo.fi/api/v1/nogotile/{z}/{x}/{y}/?depth=" + draught;
    else {
      if (deviceId === "") deviceId = "0";
      navURL =
        "https://mwend.bgeo.fi/api/v1/nogotile/{z}/{x}/{y}/?depth=" +
        draught +
        "&deviceId=" +
        deviceId;
    }

    let opacity = 1;

    let token = store.state.auth.user.token;
    console.log("token", token);
    if (!CURRENT_PRODUCT.is_navicom) {
      this.navalLayer = L.tileLayer
        .fetchTokenLayer(navURL, {
          token: token,
          minZoom: 2,
          maxZoom: 20,
          opacity: opacity,
        })
        .addTo(this.map);
    }
  }

  daysDiff(value, item) {
    if (item.appState.isActive) {
      return 0;
    }
    return utils.daysOld(value);
  }

  // Отображаем аппстейт для корабля
  showAppState(
    aindex,
    lat,
    lon,
    azimuth,
    id,
    isActive,
    name,
    route,
    sog,
    email,
    gpsDate,
    appStateDate,
    routeJson = [],
    posbyship = false
  ) {
    this.shipData[aindex] = {};

    this.shipData[aindex].route = routeJson;

    let daysOld = utils.daysOld(gpsDate);

    let iconByDays = require("../../assets/ship_1tx_green.png");
    if (!isActive && daysOld > 30) {
      iconByDays = require("../../assets/ship_1tx_grey.png");
    } else if (!isActive && daysOld > 7) {
      iconByDays = require("../../assets/ship_1tx_cyan.png");
    } else if (!isActive && daysOld > 1) {
      iconByDays = require("../../assets/ship_1tx_red.png");
    } else if (!isActive) {
      iconByDays = require("../../assets/ship_1tx_yellow.png");
    }

    let icon = L.icon({
      iconUrl: iconByDays,
      iconSize: [20, 40],
      iconAnchor: [10, 20],
    });
    this.shipData[aindex].marker = new L.marker([lat, lon], {
      icon: icon,
      rotationAngle: azimuth,
      aindex: aindex,
      deviceid: id,
      pane: "sss",
    });
    let marker = this.shipData[aindex].marker;
    let date = new Date(gpsDate);
    let local = date.toLocaleString();

    let utcLocal = "";
    if (date.getFullYear() < 2000) {
      local = "unknown";
      utcLocal = new Date(appStateDate).toLocaleString();
    }

    let tooltip = "id: " + marker.options.deviceid;
    if (name) tooltip = "name: " + name;
    if (email) tooltip += "<br>" + "user: " + email;
    if (route) tooltip += "<br>" + "route: " + route;
    if (sog && sog != "-3000") tooltip += "<br>" + "sog: " + sog + " kNots";
    if (gpsDate) tooltip += "<br>" + "last activity: " + local;
    if (utcLocal) tooltip += "<br>" + "last appstate: " + utcLocal;

    marker.bindTooltip(tooltip, { pane: "aaa" });

    marker.addTo(this.markerLayer);
    if (posbyship) {
      marker.on("click", () => {
        // console.log(file, 'shtp!')
        eventBus.$emit("ship-clicked", marker.options.aindex);
      });
    }
  }

  // Удаляем все маркеры и слои аппстейтов
  clearAppStates() {
    this.markerLayer.clearLayers();
  }

  // Добавляем контрол для измерения расстояний
  add_pMeasure(drawing = false) {
    if (this.pMeasure) {
      delete this.pMeasure;
    }
    if (drawing) {
      this.pMeasure = L.control.polylineMeasure({
        clearMeasurementsOnStop: true,
        showUnitControl: false,
        showBearings: false,
        showClearControl: true,
        clearControlTitle: "Cancel current route",
        measureControlTitleOn: "Start drawing route",
        measureControlTitleOff: "Return to manual selecting",
        unit: "nauticalmiles",
        pane: "pMeasure",
      });
    } else {
      this.pMeasure = L.control.polylineMeasure({
        clearMeasurementsOnStop: false,
        showUnitControl: false,
        unit: "nauticalmiles",
        pane: "pMeasure",
      });
    }
    this.pMeasure.addTo(this.map);
    let a = document.getElementById("polyline-measure-control");
    if (a) a.hidden = true;
  }

  // Переходим к маркеру корабля и показываем его маршрут
  paneToShip(aindex, id, name, route, sog, email, isActive, days) {
    let marker = this.shipData[aindex].marker;
    let lat = marker._latlng.lat;
    let lon = marker._latlng.lng;
    this.moveTo(lat, lon);
    this.clearRoute();
    if (this.shipData[aindex].route.length > 1) {
      this.add_pMeasure();
      let pts = [];
      this.shipData[aindex].route.forEach((pt) => {
        pts.push({
          lat: pt.latDegree,
          lon: pt.lonDegree,
        });
      });
      store.commit("routes/setRoutePoints", pts);
    }

    if (this.pMeasure && this.shipData[aindex].route.length > 1) {
      this.showRoute(aindex);
    }

    setTimeout(() => {
      marker.openTooltip();
    }, 500);

    Object.keys(this.shipData).forEach((key) => {
      // NOTE: DO NOT ===/!== with aindex
      if (key != aindex && this.shipData[key].marker) {
        this.shipData[key].marker.closeTooltip();
      }
    });
  }

  // Показываем маршрут корабля на карте
  showRoute(aindex) {
    let pts = [];
    this.shipData[aindex].route.forEach((pt) => {
      pts.push({ lat: pt.latDegree, lng: pt.lonDegree });
      console.log(pt.latDegree, pt.lonDegree);
    });
    // переключаем состояние рисования
    this.pMeasure._toggleMeasure();
    // начинаем линию с первой точки каждого полилинии
    this.pMeasure._startLine(pts[0]);
    // добавляем последующие точки:
    pts.forEach((point, ind) => {
      const latLng = L.latLng(point);
      this.pMeasure._mouseMove({ latLng });
      this.pMeasure._currentLine.addPoint(latLng);
      // на последней точке,
      if (ind === pts.length - 1) {
        this.pMeasure._finishPolylinePath();
        this.pMeasure._toggleMeasure();
      }
    });
  }

  // these methods are being called, but did not exist.
  // create empty one to avoid errors
  restoreContextAfterAuto() {}

  removeRoute() {}
}
